import {
  defineTargetTableConfig,
  TargetTable,
  TargetTableProps,
} from 'components/DataExpansionComponents/Common/TargetTable/TargetTable'
import LodgingExportModal from 'components/Modals/ExportModal/LodgingExportModal'
import { LodgingFilterset } from './LodgingFilterset'
import { useLodgingTableCols } from './LodgingTableColumns'

const sortableFields: string[] = [
  'note_count',
  'contact_count',
  'deal_count',
  'name',
  'domain',
  'reviews_avg',
  'reviews_cnt',
  'doors_cnt',
]

export const lodgingTableConfig = defineTargetTableConfig({
  // Lodging chain detail link reads `lodging.id` (GooglePlaceBase name cell,
  // accesor="lodging").
  vertical: 'lodging',
  rowConfig: { nestKey: 'lodging' },
  filterIdentifier: 'LODGING_TABLE',
  savedPresetsIdentifier: 'LODGING_TABLE',
  companyTypeSlug: 'lodging-hospitality',
  tableTypeSlug: 'lodging-hospitality',
  sortableFields,
  preferredGroupOrder: [
    'Target Attributes',
    'Hotel Amenities',
    'Campaigns and Deals',
  ],
  searchPlaceholder: 'Search lodging by name',
  useColumns: useLodgingTableCols,
  Filterset: LodgingFilterset,
  ExportModal: LodgingExportModal,
})

// Lodging is the one generic vertical that exposes `AfterSearchComponent`, so it
// takes the full TargetTableProps (the other five Omit it).
export function LodgingTable(props: TargetTableProps) {
  return <TargetTable config={lodgingTableConfig} {...props} />
}
